import { useLocation } from "react-router-dom";

import { type InstallableApp } from "~/pwa/installableApps";
import standaloneLaunch from "~/pwa/standaloneLaunch";

const useStandaloneApp = (): { activeApp: InstallableApp | null; isConfined: boolean } => {
	// react-router: re-render on navigation so a pin released by FlagDeniedRedirect is re-read.
	useLocation();
	const { app: launchedApp } = standaloneLaunch.resolve();
	return { activeApp: launchedApp, isConfined: launchedApp !== null };
};

export default useStandaloneApp;
